/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'percentCircle': {
    width: 14,
    height: 14,
    viewBox: '0 0 14 14',
    data: '<g _fill="#686a7a" fill-rule="nonzero"><path pid="0" d="M7 5.25c0-.965-.785-1.75-1.75-1.75S3.5 4.286 3.5 5.25C3.5 6.215 4.285 7 5.25 7S7 6.215 7 5.25Zm-2.333 0a.584.584 0 0 1 1.166 0 .584.584 0 0 1-1.166 0ZM8.75 7C7.785 7 7 7.785 7 8.75s.785 1.75 1.75 1.75 1.75-.785 1.75-1.75C10.5 7.786 9.715 7 8.75 7Zm0 2.333a.584.584 0 1 1 .001-1.168.584.584 0 0 1-.001 1.168Z"/><path pid="1" d="m4.254 8.922 4.667-4.667.825.825L5.08 9.747z"/><path pid="2" d="M7 1.167A5.84 5.84 0 0 0 1.167 7 5.84 5.84 0 0 0 7 12.833 5.84 5.84 0 0 0 12.833 7 5.84 5.84 0 0 0 7 1.167Zm0 10.5A4.672 4.672 0 0 1 2.333 7 4.672 4.672 0 0 1 7 2.333 4.672 4.672 0 0 1 11.667 7 4.672 4.672 0 0 1 7 11.667Z"/></g>'
  }
})
